<script setup>
import { ref, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { getI18n } from '@/plugins/i18n'

import { useAccountingStore } from '@/stores/accounting.store'
import { useWebSiteStore } from '@/stores/web-site.store'

import { useDetectDevice } from '@/composables/device'

import ExpenseClaimsList from '@/components/accounting/ExpenseClaimsList.vue'
import ExpenseClaimsGrid from '@/components/accounting/ExpenseClaimsGrid.vue'
import PageTabs from '@/components/shared/PageTabs.vue'

const i18n = getI18n()
const route = useRoute()
const router = useRouter()
const accountingStore = useAccountingStore()
const webSiteStore = useWebSiteStore()
const { isMobile } = useDetectDevice()
const { expenseClaimScopeEnum } = accountingStore

const claimsTab = 'claims'
const tabs = [{ name: claimsTab, label: i18n.t('menu.accounting.expense_claims') }]

const staffScope = webSiteStore.canApproveExpenseClaims ? expenseClaimScopeEnum.STAFF : expenseClaimScopeEnum.MINE

const expenses = ref(null)

const openRouteClaimAsync = async() => {
  const claimId = Number(route.query.expense_claim)
  if (!claimId) return
  const query = { ...route.query }
  delete query.expense_claim
  router.replace({ query })
  await nextTick()
  await expenses.value?.openClaimAsync(claimId)
}
watch(() => route.query.expense_claim, openRouteClaimAsync, { immediate: true })

</script>

<template>
  <page-tabs :model-value="claimsTab" :tabs="tabs">
    <q-tab-panel :name="claimsTab" class="q-pa-none column no-wrap">
      <expense-claims-list
        v-if="isMobile"
        ref="expenses"
        class="col"
        :scope="staffScope"
      />
      <expense-claims-grid
        v-else
        ref="expenses"
        class="col"
        :scope="staffScope"
      />
    </q-tab-panel>
  </page-tabs>
</template>
